require('./shared/flash_messages')
require('./shared/cookie_banner')
